export const UserRole = {
  Admin: "ADMIN",
  Editor: 1,
  Staff: "Staff",
  Customer: "CUSTOMER"
};
